import {requirePermission} from '@/modules/auth/permissions'
import {PharmaciesTable} from '@/modules/pharmacies/components'
import {PharmacysFilters} from '@/modules/pharmacies/components/pharmacy-filters'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {HStack} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'
import {LuPlus} from 'react-icons/lu'
import {ResourcesIndexPageTable} from '@/shared/components/ui/resources-index-page-table'
import * as z from 'zod'
import {useGetInfinitePharmacies} from '@/modules/pharmacies/api'

const SearchSchema = z.object({
  filters: z.object({search: z.string().optional()}).optional(),
})

export const Route = createFileRoute('/configuration/pharmacies/')({
  beforeLoad: requirePermission('organisation.manage'),
  component: PharmaciesPage,
  validateSearch: SearchSchema,
})

const LIMIT = 50

function PharmaciesPage() {
  const {t} = useTranslate('common')

  const search = Route.useSearch()

  const infinitePharmacies = useGetInfinitePharmacies({
    limit: LIMIT,
    sort: {
      dir: 'desc',
      field: 'createdAt',
    },
    filters: {
      name: search.filters?.search,
      status: [],
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infinitePharmacies

  return (
    <>
      <HStack justifyContent="space-between" width="100%">
        <LinkButton to="/configuration/pharmacies/new" marginY="1rem" colorPalette="cyan" size="sm">
          <LuPlus />
          {t('add_new')}
        </LinkButton>

        <PharmacysFilters />
      </HStack>
      <ResourcesIndexPageTable>
        <PharmaciesTable virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}} table={{}} />
      </ResourcesIndexPageTable>
    </>
  )
}
